import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import defaultHeroImg from "../../images/no-hero-default.svg";

const NotchedImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  ${props => props.theme.media.tabletUp`
    left: 0;
  `};
`;

const StyledGatsbyImage = styled(GatsbyImage)`
  border-radius: ${props => (props.hasBorderRadius ? "10px" : "0")};
`;

const DefaultImage = styled.img`
  min-height: 165px;
  max-width: 100%;
  object-fit: cover;
`;

export default props => {
  const { className, alt, imageData, hasBorderRadius } = props;
  const image = getImage(imageData);
  return (
    <NotchedImageWrapper className={className}>
      {image ? (
        <StyledGatsbyImage
          hasBorderRadius={hasBorderRadius}
          image={image}
          alt={alt}
          objectFit="contain"
        />
      ) : (
        <DefaultImage src={defaultHeroImg} alt={alt} />
      )}
    </NotchedImageWrapper>
  );
};
